import { BookOpen, Clock, Globe } from 'lucide-react';

const HISTORY_IMG = "https://images.unsplash.com/photo-1590509038652-23272b923485?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYmx1ZSUyMGdvbGQlMjB0ZXh0dXJlfGVufDB8fHx8MTc3NTg1NTc5N3ww&ixlib=rb-4.1.0&q=85";

const TIMELINE = [
  { era: "Ancient Origins", period: "~1200 CE", desc: "The sitar evolved from the Persian setar and the Indian veena, combining Persian and Indian musical traditions during the medieval period." },
  { era: "Mughal Court", period: "16th-18th Century", desc: "Flourished under Mughal patronage. Amir Khusrau is often credited with its development, though this remains debated among scholars." },
  { era: "Gharana Traditions", period: "19th Century", desc: "Distinct schools (gharanas) emerged — Senia, Maihar, Etawah-Imdadkhani — each developing unique techniques and repertoires." },
  { era: "Global Recognition", period: "20th Century", desc: "Pandit Ravi Shankar brought the sitar to world audiences, performing with Western musicians and at iconic festivals worldwide." },
];

export default function HistorySection() {
  return (
    <section id="history" data-testid="history-section" className="py-24 md:py-32 px-6 md:px-12 relative">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-start">
          <div>
            <p className="text-sm uppercase tracking-[0.2em] text-[#d4af37] mb-4 flex items-center gap-2">
              <BookOpen className="w-4 h-4" /> Heritage
            </p>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#fdfbf7] mb-6 tracking-tight leading-tight">
              A Legacy Spanning<br />Centuries
            </h2>
            <p className="text-[#a3b1c6] leading-relaxed mb-8 text-base">
              The sitar is more than an instrument — it is a living tradition that carries within it
              centuries of devotion, innovation, and cultural exchange. From the courts of the
              Mughal emperors to the concert halls of the modern world, the sitar's resonance
              has touched millions of souls.
            </p>
            <div className="relative rounded-xl overflow-hidden border border-[#d4af37]/20">
              <img src={HISTORY_IMG} alt="Sitar heritage" className="w-full h-64 object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] to-transparent" />
            </div>
          </div>

          <div className="space-y-6">
            {TIMELINE.map((item) => (
              <div
                key={item.era}
                className="bg-[#122036] border border-[#d4af37]/20 rounded-xl p-6 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(212,175,55,0.1)] transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="flex items-center gap-2 text-[#d4af37]">
                    {item.era === "Global Recognition" ? <Globe className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
                    <span className="text-xs uppercase tracking-wider font-medium">{item.period}</span>
                  </div>
                </div>
                <h3 className="font-['Cormorant_Garamond'] text-xl md:text-2xl text-[#fdfbf7] mb-2">{item.era}</h3>
                <p className="text-[#a3b1c6] text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="section-divider mt-24 md:mt-32 max-w-4xl mx-auto" />
    </section>
  );
}
